import BaseTable, {FieldType} from "../table/BaseTable.tsx";
import NewAttributeModal from "../modal/NewAttributeModal.tsx";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store";
import {useMemo, useState} from "react";
import {attribute} from "@/store/modules/attribute.ts";
import BulkUploadModalNew from "../modal/BulkUploadModalNew.tsx";
import DeleteAttributeModal from "../modal/DeleteAttributeModal.tsx";
import {ReadAttributeResponse} from "@/model/response/attribute/ReadAttributeResponse.ts";
import NavBarHeading from "@/components/menu/NavBarHeading.tsx";
import {base} from "@/store/modules/base.ts";
import {ModalConstant} from "@/util/constant/ModalConstant.ts";
import {useFirstRender} from "@/util/useFirstRender.tsx";

export default function AttributePage() {
    const applicationState = useSelector((state: RootState) => state.application);
    const entityState = useSelector((state: RootState) => state.entity);
    const attributeState = useSelector((state: RootState) => state.attribute);
    const workspaceState = useSelector((state: RootState) => state.workspace);

    const [showModal, setShowModal] = useState(false);
    const [attributeData, setAttributeData] = useState<Partial<ReadAttributeResponse> | null>({});
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const dispatch = useDispatch<any>();
    const isFirstRender = useFirstRender()
    const toggleVisibility = () => {
        setShowModal(true)
    }


    const items = useMemo(() => {
        if (isFirstRender) {
            dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState?.selectedEntity?.entityId ? entityState?.selectedEntity?.entityId : 0}))
            return []
        }
        return attributeState.attributeById
    }, [attributeState.attributeById])

    const refreshPage = () => {
        dispatch(attribute.action.read())
    }

    const fields: FieldType[] = [
        {
            label: "Attribute Name", key: "attributeName", onClick: (data) => {
                dispatch(attribute.mutation.setSelectedAttribute(data))
                toggleVisibility()
                setAttributeData(data)
            }
        },
        {label: "Data Type", key: "attributeDataType"},
        {label: "Foreign Key", key: "attributeForeignKey"},
        {label: "Primary Key", key: "attributePrimaryKey"},
        {label: "Null", key: "attributeNull"},
        {label: "Auto Increment", key: "attributeAutoIncrement"},
        {label: "Unique", key: "attributeUnique"},
        {label: "Value List", key: "attributeValueList"},
        {label: "Start Value", key: "attributeStartValue"},
        {label: "Attribute Reference Attribute", key: "attributeReferenceAttribute"},
        {label: "Attribute Reference Entity", key: "attributeReferenceEntity"},
        {label: "Required Delete", key: "attributeIsRequiredDelete"},
        {label: "Required Create", key: "attributeIsRequiredCreate"},
        {label: "Required Update", key: "attributeIsRequiredUpdate"},
    ]
    return (
        <section
                className="app-content-dashboard"
                style={{backgroundColor: "white"}}
            >
                <div className="title-wrapper">
                    <div className="margin-bottom">
                        <h5 className={"h5-header"}> {`${workspaceState.selectedWorkspace?.workspaceName?.toUpperCase()} > ${applicationState?.selectedApplication?.applicationName?.toUpperCase()}
                        > ${entityState.selectedEntity?.entityName?.toUpperCase()}`}</h5>
                    </div>
                    <NavBarHeading/>
                </div>
                <section className="project-table-wrapper">
                    <div className="table-actions-wrapper">
                        <div style={{display: "flex", gap: "1rem"}}>
                            <a onClick={() => {
                                toggleVisibility()
                                setAttributeData(null)
                            }} className="button">
                                Create New Attribute
                            </a>
                            <a onClick={() => dispatch(base.mutation.setModalOptions({
                                show: true,
                                component: ModalConstant.authConfig
                            }))} className="button is-secondary">
                                Create Auth Config
                            </a>
                            {/*<a href={import.meta.env.VITE_DOWNLOAD_BASE_URL + applicationState?.selectedApplication?.applicationId}*/}
                            {/*   target="_blank" className="button is-secondary ">*/}
                            {/*    Download Codes*/}
                            {/*</a>*/}
                        </div>
                        <div>
                            <a onClick={() => setShow(true)} className="button"
                               style={{color: "white", backgroundColor: "#252f3d", border: "none"}}>
                                Excel Upload
                            </a>
                            <BulkUploadModalNew onClose={() => setShow(false)} show={show}/>
                        </div>
                    </div>
                    <div className="margin-top">
                    </div>
                    <div style={{width: '100%', marginLeft: 'auto'}}>
                        <BaseTable title={"Attributes"} component={""} items={items ?? []}
                                   refreshPage={refreshPage}
                                   showToast={false} loader={attributeState.loading} fields={fields}
                                   actions={{view: true}}
                                   rowOptions={[{
                                       optionName: 'View Attribute', onClick: (data) => {
                                           dispatch(attribute.mutation.setSelectedAttribute(data))
                                       },
                                       optionStyle:{fontSize:12}
                                   },
                                       {
                                           optionName: 'Edit Attribute', onClick: (data) => {
                                               dispatch(attribute.mutation.setSelectedAttribute(data))
                                               toggleVisibility()
                                               setAttributeData(data)
                                           },
                                           optionStyle:{fontSize:12}
                                       }, {
                                           optionName: 'Delete Attribute', onClick: (data) => {
                                               dispatch(attribute.mutation.setSelectedAttribute(data))
                                               setDeleteModal(true)
                                           },
                                           optionStyle:{fontSize:12}
                                       },

                                   ]}

                        />
                        {showModal && (
                            <NewAttributeModal
                                show={showModal}
                                onClose={() => setShowModal(false)}
                                data={attributeData}
                            />
                        )}
                        {deleteModal && (
                            <DeleteAttributeModal
                                show={deleteModal}
                                onClose={() => setDeleteModal(false)}
                            />
                        )}
                    </div>
                </section>
            </section>
    );
}